import PropTypes from 'prop-types';
import React from 'react';
import styled, { css, ThemeProvider } from 'styled-components';

import colors from './constants/colors';
import mediaQueries from './constants/mediaQueries';
import { BANNER_HEIGHT_DESKTOP, BANNER_HEIGHT_MOBILE } from './Error';

const theme = {
  responsiveBreakpoint: 1024,
  spacingUnit: 8,
};

const SIDEBAR_WIDTH = '396px';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100vw;

  ${mediaQueries.desktop`
    background-color: ${colors.ghostWhite};
    height: 100vh;
  `}
`;

const Shadow = styled.div`
  height: 100%;
  width: 100%;

  ${mediaQueries.desktop`
    box-shadow:
      0 1px 10px 0 ${colors.littleDipper},
      0 4px 5px 0 ${colors.littleDipper},
      0 2px 4px -1px ${colors.lunarRays};
    max-height: 860px;
    max-width: 1600px;
  `}
`;

const Container = styled.div`
  background-color: white;
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100vw;

  ${mediaQueries.desktop`
    max-height: 860px;
    max-width: 1600px;
    overflow-y: hidden;
    position: fixed;
  `}
`;

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    <Wrapper>
      <Shadow>
        <Container>{children}</Container>
      </Shadow>
    </Wrapper>
  </ThemeProvider>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

Layout.Sidebar = styled.div`
  width: 100%;

  ${props =>
    props.displayOnMobile &&
    css`
      flex: 0 1 auto;
      height: 56px;
    `}

  ${mediaQueries.desktop`
    height: 100%;
    position: absolute;
    right: 0;
    width: ${SIDEBAR_WIDTH};

    ${props =>
      props.position === 'left' &&
      css`
        left: 0;
        right: auto;
      `}
  `}
`;

Layout.Page = styled.div`
  background-color: ${props => props.backgroundColor};
  flex: 1 1 auto;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;

  ${mediaQueries.desktop`
    ${({ hasTopBanner }) => hasTopBanner && `padding-top: ${BANNER_HEIGHT_DESKTOP}`};
    height: calc(100% - 72px);
    width: calc(100% - ${({ hasSidebar }) => (hasSidebar ? SIDEBAR_WIDTH : '0px')});
  `}

  ${mediaQueries.mobile`
    ${({ hasTopBanner }) => hasTopBanner && `padding-top: ${BANNER_HEIGHT_MOBILE}`};
  `}
`;

Layout.Page.propTypes = {
  hasTopBanner: PropTypes.bool,
  hasSidebar: PropTypes.bool,
};

Layout.Page.defaultProps = {
  hasTopBanner: false,
  hasSidebar: false,
};

Layout.Footer = styled.footer`
  bottom: 0;
  flex: 0 1 auto;
  height: 72px;
  width: 100%;
  background-color: ${colors.white};
  z-index: 2;

  ${mediaQueries.desktop`
    width: calc(100% - ${({ hasSidebar }) => (hasSidebar ? SIDEBAR_WIDTH : '0px')});
  `}
`;

Layout.Footer.propTypes = {
  hasSidebar: PropTypes.bool,
};

Layout.Footer.defaultProps = {
  hasSidebar: false,
};

export default Layout;
